module.exports = __webpack_public_path__ + "img/icon8.83f1c10d.svg";